import React from 'react';
import { BiSolidMinusSquare } from 'react-icons/bi';

export const DEFAULT_UNAVAILABLE_REASON =
  'These entities are already associated with an existing connection.';

interface UnavailableEntitiesProps {
  accounts: Array<{ companyName: string; unavailableReason?: string }>;
}

const UnavailableEntities: React.FC<UnavailableEntitiesProps> = ({
  accounts,
}) => {
  if (!accounts || accounts.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        flex: '1 1 auto',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      {accounts.map((account, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #e1e5e9',
            backgroundColor: '#f8f9fa',
            fontSize: '16px',
            fontWeight: 400,
            color: '#9ca3af',
          }}
        >
          <BiSolidMinusSquare
            size={20}
            style={{ color: '#9ca3af', flexShrink: 0 }}
          />
          <span
            style={{
              flex: 1,
              textAlign: 'left',
              overflowWrap: 'break-word',
              overflow: 'auto',
            }}
          >
            {account.companyName}
          </span>
        </div>
      ))}
    </div>
  );
};

export default UnavailableEntities;
